import { StatusLabel } from '@shared/components/StatusLabel';
import { useTranslation } from '@shared/core';
import { Flex, JoyKitThemeProvider, TooltipV2 } from '@withjoy/joykit';
import { pxToRem } from '@withjoy/joykit/theme';
import React from 'react';

export const ReservationsCount = ({ reservationsCount }: { reservationsCount: number }) => {
  const { t } = useTranslation('guestSiteCustom');
  const accTrans = t('accommodations');
  return (
    <JoyKitThemeProvider>
      <TooltipV2
        overrides={{ Content: { props: { borderRadius: 6 } } }}
        content={
          <Flex
            flexDirection="column"
            maxWidth={pxToRem(256)}
          >
            <Flex
              typographyVariant={'label3'}
              color="white"
              fontWeight={700}
            >
              {accTrans.bookedTooltipTitle.bookedTooltipTitle({ reservationsCount, count: reservationsCount })}
            </Flex>
            <Flex
              typographyVariant={'label2'}
              color="white"
              fontWeight={400}
            >
              {accTrans.bookedTooltipBody.bookedTooltipBody({ reservationsCount, count: reservationsCount })}
            </Flex>
          </Flex>
        }
      >
        <StatusLabel gap={3}>{accTrans.numberOfBookings.numberOfBookings({ reservationsCount, count: reservationsCount })}</StatusLabel>
      </TooltipV2>
    </JoyKitThemeProvider>
  );
};
